import { EditorVoiceAction, type EditorVoiceMode } from "./EditorVoiceAction";

/** The single bottom action block shared by every full-screen editor. */
export function EditorBottomBar({ mode, label, microphoneLabel, text, error, progressText, voiceDisabled = false, doneDisabled = false, doneText = "Готово", onMicrophone, onDone }: {
  mode: EditorVoiceMode; label: string; microphoneLabel?: string;
  text: string; error: string; progressText: string;
  voiceDisabled?: boolean; doneDisabled?: boolean; doneText?: string;
  onMicrophone: () => void; onDone: () => void;
}) {
  return <div className="editor-bottom-bar">
    <EditorVoiceAction mode={mode} label={label} {...(microphoneLabel ? { microphoneLabel } : {})} text={text} error={error} progressText={progressText} disabled={voiceDisabled} onMicrophone={onMicrophone} />
    <button className="voice-primary debug-done meal-done" type="button" disabled={doneDisabled} onClick={onDone}>{doneText}</button>
  </div>;
}
